<div class="account-menu">
    <form [formGroup]="form" *ngIf="!user" class="account-menu__form" (ngSubmit)="login()">
        <div class="account-menu__form-title">{{"log_in"|translate}}</div>
        <div class="form-group">
            <label for="header-signin-email" class="sr-only">{{"emai_address"|translate}}</label>
            <input id="header-signin-email" type="email" class="form-control form-control-sm"
                placeholder="Email address" formControlName="email" required>
            <div *ngIf="submitted && form.controls['email'].errors || form.controls['email'].invalid && (form.controls['email'].dirty || form.controls['email'].touched)"
                class="tetx-danger">
                <small *ngIf="form.controls['email'].errors.required">
                    {{"email_required"|translate}}.
                </small>
            </div>
        </div>
        <div class="form-group">
            <label for="header-signin-password" class="sr-only">{{"password"|translate}}</label>
            <div class="account-menu__form-forgot">
                <input id="header-signin-password" type="password" class="form-control form-control-sm"
                    placeholder="Password" formControlName="password">
                <a routerLink="/forgot-password" class="account-menu__form-forgot-link" (click)="closeMenu.emit()">{{"forgot"|translate}}</a>
            </div>
            <div *ngIf="submitted && form.controls['password'].errors || form.controls['password'].invalid && (form.controls['password'].dirty || form.controls['password'].touched)" class="text-danger">
                <small *ngIf="form.controls['password'].errors.required">
                    {{"password_required"|translate}}.
                </small>
            </div>
        </div>
        <div class="form-group account-menu__form-button">
            <button type="submit" class="btn btn-primary btn-sm">{{"login"|translate}}</button>
        </div>
        <div class="account-menu__form-link"><a routerLink="/register" (click)="closeMenu.emit()">{{"create_account"|translate}}</a></div>
    </form>
    <div class="account-menu__divider"></div>
    <div *ngIf="user">
        <a routerLink="/account/dashboard" class="account-menu__user" (click)="closeMenu.emit()">
            <!-- <div class="account-menu__user-avatar">
                <img src="assets/images/avatars/avatar-3.jpg" alt="">
            </div> -->
            <div class="account-menu__user-info">
                <div class="account-menu__user-name">{{user.name}}</div>
                <div class="account-menu__user-email">{{user.email}}</div>
            </div>
        </a>
        <div class="account-menu__divider"></div>
        <ul class="account-menu__links">
            <li><a routerLink="/account/profile" (click)="closeMenu.emit()">{{"edit_profile"|translate}}</a></li>
            <!-- <li><a routerLink="/account/subscription" (click)="closeMenu.emit()">{{"subscription"|translate}}</a></li> -->
            <li><a routerLink="/account/orders" (click)="closeMenu.emit()">{{"order_history"|translate}}</a></li>
            <li><a routerLink="/account/quotation-drafts" (click)="closeMenu.emit()">{{"quotation_history"|translate}}</a></li>
            <li><a routerLink="/account/messages" (click)="closeMenu.emit()">{{"messages"|translate}}</a></li>
            <li><a routerLink="/account/live-chat" (click)="closeMenu.emit()">{{"live_chat"|translate}}</a></li>
            <li><a routerLink="/account/addresses" (click)="closeMenu.emit()">{{"addresses"|translate}}</a></li>
            <li><a routerLink="/account/password" (click)="closeMenu.emit()">{{"password"|translate}}</a></li>
        </ul>
        <div class="account-menu__divider"></div>
        <div class="account-menu__divider"></div>
        <div class="p-2">
            <app-country-select variant="menu"></app-country-select>
        </div>
        <div class="account-menu__divider"></div>
        <ul class="account-menu__links">
            <li><a routerLink="" (click)="logout()">{{"logout"|translate}}</a></li>
        </ul>
    </div>
</div>
